import { PreviewStoryPage } from './PreviewStoryPage'
import { withPreviewStoryPage } from './withPreviewStoryPage'

const ConnectedPreviewStoryPage = withPreviewStoryPage(PreviewStoryPage)

export { ConnectedPreviewStoryPage as PreviewStoryPage }
